import './progressBar.scss'
import templateUrl from './progressBar.html'

/**
 * Animated progress bar component
 *
 * @example
 * <tmr-progress-bar
 *   progress-background-color=""
 *   progress-bar-color=""
 *   progress-current=""
 *   progress-max=""
 *   progress-label=""
 * ></tmr-progress-bar>
 *
 * @type {ngComponent}
 * @prop {string=} progress-background-color Defaults to light accent
 * @prop {string=} progress-bar-color Defaults to temeraGreen
 * @prop {number} progress-current
 * @prop {number} progress-max Defaults to 100
 * @prop {string} progress-label A localized string to show over the progress bar
 * @prop {'tooltip'|'inline'} [progress-label-type=tooltip] How to display the progress count. The format is "current/max"
 */
export const tmrProgressBar = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrProgressBarController',
  bindings: {
    progressBackgroundColor: '<?',
    progressBarColor: '<?',
    progressCurrent: '<',
    progressMax: '<?',
    progressLabel: '<?',
    progressLabelType: '@?',
  },
}

/**
 * Controller of component {@link tmrProgressBar}.
 *
 * @type {ngController}
 */
export class tmrProgressBarController {
  static ngType = 'controller'

  constructor($mdColors) {
    'ngInject'
    Object.assign(this, { $mdColors })
  }

  $onInit() {
    this.progressBackgroundColor =
      this.progressBackgroundColor ?? this.$mdColors.getThemeColor('accent-200')
    this.progressBarColor =
      this.progressBarColor ?? this.$mdColors.getThemeColor('temeraGreen')
    this.progressMax =
      typeof this.progressMax === 'number' ? this.progressMax : 100
  }

  /**
   * Returns a css background that looks like a percentage based progress bar.
   */
  style() {
    let percent =
      this.progressMax === 0
        ? 0
        : Math.round((this.progressCurrent * 100) / this.progressMax)
    return {
      background: `linear-gradient(to right, ${this.progressBarColor} ${percent}%, ${this.progressBackgroundColor} 0)`,
    }
  }
}
